import React from 'react'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'
import BalanceSheetComp from './BalanceSheetComp'

function BalanceSheet() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <BalanceSheetComp/>
        </div>
    </div>
  )
}

export default BalanceSheet
